export var CustomerChatRoomState;
(function (CustomerChatRoomState) {
    CustomerChatRoomState["OPENED"] = "OPENED";
    CustomerChatRoomState["CLOSED"] = "CLOSED";
})(CustomerChatRoomState || (CustomerChatRoomState = {}));
